import { useSelector, useDispatch } from 'react-redux';
import FJMobileImageExtenderEdit from './FJMobileImageExtenderEdit';
import FJActionImageExtender from '../../../redux/action/FJActionImageExtender';
import { useCallback } from 'react';
import useLocalStore from '../../../hooks/useLocalStore';
const FJMobileImageExtenderEditContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const curRatioName = useSelector(state => state.imageExtender.curRatioName);
    const generateNumber = useSelector(state => state.imageExtender.generateNumber);

    const handleChangeGenerateNumber = useCallback(
        value => {
            dispatch(FJActionImageExtender.changeGenerateNumberAction(value));
        },
        [dispatch],
    );
    const changeRatio = useCallback(
        ratio => {
            dispatch(FJActionImageExtender.setCurRatioNameAction(ratio));
        },
        [dispatch],
    );
    const uploadImg = useCallback(
        file => {
            dispatch(FJActionImageExtender.uploadImageAction(file));
        },
        [dispatch],
    );
    const onGenerate = useCallback(() => {
        dispatch(FJActionImageExtender.generateAction());
    }, [dispatch]);
    const useCredit = 2 * generateNumber;
    const isFree = freeNumCreation > 0 && useCredit > creditNumber;
    return (
        <FJMobileImageExtenderEdit
            onGenerate={onGenerate}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            isProjectLoading={isProjectLoading}
            uploadImg={uploadImg}
            isFree={isFree}
            useCredit={useCredit}
            curRatioName={curRatioName}
            changeRatio={changeRatio}
            generateNumber={generateNumber}
            handleChangeGenerateNumber={handleChangeGenerateNumber}
        />
    );
};

export default FJMobileImageExtenderEditContainer;
